// extracted by mini-css-extract-plugin
export default {"zoomModal":"L2-z","image":"M2-z","button":"N2-z","isOverlayShown":"O2-z"};